import { render } from "./ModalRankingLegend.vue?vue&type=template&id=79e7c163&scoped=true"
import script from "./ModalRankingLegend.vue?vue&type=script&lang=js"
export * from "./ModalRankingLegend.vue?vue&type=script&lang=js"

import "./ModalRankingLegend.vue?vue&type=style&index=0&id=79e7c163&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79e7c163"

export default script